import { motion } from "framer-motion";
import {
  Zap,
  Wallet,
  FileX,
  ShieldCheck,
  Users,
  TrendingUp,
} from "lucide-react";

const reasons = [
  {
    icon: <Zap className="w-5 h-5 text-[#7C3AED]" />,
    title: "Experiencia sin vueltas",
    text: "Te decimos qué hace y qué no hace el sistema, antes de que pagues. No prometemos nada que no podemos hacer.",
  },
  {
    icon: <FileX className="w-5 h-5 text-[#7C3AED]" />,
    title: "Sin contrato",
    text: "Cancelás cuando quieras. No usamos el contrato para asustarte.",
  },
  {
    icon: <Wallet className="w-5 h-5 text-[#7C3AED]" />,
    title: "Precio claro",
    text: 'Sabés exactamente qué pagás y por qué servicio. Nada de "depende" en la llamada.',
  },
  {
    icon: <ShieldCheck className="w-5 h-5 text-[#7C3AED]" />,
    title: "Vos no tocás nada",
    text: "Completás dos datos por mes. El resto lo armamos y lo mantenemos nosotros.",
  },
  {
    icon: <Users className="w-5 h-5 text-[#7C3AED]" />,
    title: "Con casos reales",
    text: "Te mostramos cuentas de clientes reales funcionando, no una demo armada para la ocasión.",
  },
  {
    icon: <TrendingUp className="w-5 h-5 text-[#7C3AED]" />,
    title: "Un reporte todos los lunes",
    text: "Ves la plata que tenés en la calle sin tener que pedirlo.",
  },
];

export const WhyUsSection = () => {
  return (
    <section className="bg-[#08080A] py-24 lg:py-[160px] relative">
      <div className="container mx-auto px-6 max-w-[1200px]">
        <div className="max-w-3xl mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-[#71717A] font-mono text-[13px] tracking-[0.08em] uppercase mb-6">
              ● POR QUÉ SOMOS DISTINTOS
            </p>
            <h2 className="text-[32px] md:text-[44px] lg:text-[56px] font-medium text-[#FAFAFA] tracking-[-0.03em] leading-[1.05] mb-6">
              Por qué somos "distintos", como dice todo el mundo...
            </h2>
            <p className="text-[#A1A1AA] text-[16px] md:text-[17px] leading-[1.6]">
              Ninguno de estos seis puntos es un truco de marketing. Son la
              razón por la que nuestros clientes se quedan
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{
                duration: 0.6,
                delay: index * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="bg-[#0F0F11] border border-white/5 rounded-[16px] p-6 hover:border-white/10 transition-all duration-300"
              style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)" }}
            >
              <div className="w-10 h-10 bg-white/5 border border-white/10 rounded-[10px] flex items-center justify-center mb-4">
                {reason.icon}
              </div>
              <h3 className="text-[#FAFAFA] text-[17px] font-medium tracking-[-0.03em] mb-2">
                {reason.title}
              </h3>
              <p className="text-[#A1A1AA] text-[14px] leading-[1.5]">
                {reason.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
